import { useAtom } from 'jotai';
import { Socket } from 'socket.io-client';
import { socketAtom } from '../socketStore.atoms';

type TSetSocket = (value: Socket | null) => void;

export const useSocket = (): [Socket | null, TSetSocket] => useAtom(socketAtom);
